"use strict";
/// <reference path="irep.js"/>

IREP.skills = (function () {
    var init = function() {
        var complete;
        
        $('.skillSubContainer').on('mouseover', function (e) {
            var color = $(this).children('#hidSkillColor').val();
            complete = $(this).children('#hidSkillComplete').val();

            if (complete === "True") {
                $(this).siblings('.skillItemContainer').addClass(color + "BG");
            }
            else {
                $(this).siblings('.skillItemContainer').addClass("ContainerHover");
            }

        });
        $('.skillSubContainer').on('mouseout', function (e) {
            complete = $(this).children('#hidSkillComplete').val();

            if (complete === "False") {
                $(this).siblings('.skillItemContainer').removeClass("ContainerHover");
            }

        });

        $('.skillItemContainer').on('mouseover', function (e) {
            var color = $(this).siblings('.skillSubContainer').children('#hidSkillColor').val();
            $(this).siblings('.skillSubContainer').addClass("SubHover" + color);
            complete = $(this).siblings('.skillSubContainer').children('#hidSkillComplete').val();
            if (complete === "False") {
                $(this).addClass("ContainerHover");
            }

        });
        $('.skillItemContainer').on('mouseout', function(e) {
            var color = $(this).siblings('.skillSubContainer').children('#hidSkillColor').val();
            $(this).siblings('.skillSubContainer').removeClass("SubHover" + color);

            complete = $(this).siblings('.skillSubContainer').children('#hidSkillComplete').val();

            if (complete === "False") {
                $(this).removeClass("ContainerHover");
            }

        });
    };

    return {
        init: init
    };
})();